import React, { useState } from "react";
import "./Special_Instructions_Modal.css";
import { Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import classNames from "classnames";

import Success_Modal from "../success_modal/Success_Modal";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";

function Special_Instructions_Modal({
  setDeliveryNote,
  deliveryNote,
  ...props
}) {
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const onSubmit = (data) => {
    setDeliveryNote(data?.table_no);

    console.log(deliveryNote, "deliveryNote deliveryNote");

    props?.onHide();
    setShowSucsessModal(true);

    setTimeout(() => {
      props?.onHide();
      setShowSucsessModal(false);
    }, 3000);
  };

  return (
    <>
      <section className=" Special_Instructions_Modal modal-holder">
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className=" Special_Instructions_Modal modal-holder"
        >
          <Modal.Header className="common_modal_header">
            <Modal.Title>Add Delivery Note</Modal.Title>
            <div className="right_side_close_modal_btn">
              <img
                src="/assets/images/cart/close.png"
                className="close_modal_img"
                onClick={() => {
                  props?.onHide();
                }}
              />
            </div>
          </Modal.Header>

          <Modal.Body>
            <form>
              <div className="main_modal_holder">
                <div className="input_div">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="table_no"
                    placeholder="Type your special request here (0 - 200 words)"
                    {...register("table_no", {
                      required: "This field is required",
                      validate: (value) =>
                        value.split(" ").length <= 200 ||
                        "Maximum 200 words allowed",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.table_no,
                      "is-valid": getValues("table_no"),
                    })}
                  />
                  {errors.table_no && (
                    <p className="text-danger">{errors.table_no.message}</p>
                  )}
                </div>

                <p className="limit-text">200 word limit</p>

                <div className="btn_holder  ">
                  <Green_Btn
                    btn_name="Submit"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <Success_Modal
          show={showSuccessModal}
          onHide={() => {
            setShowSucsessModal(false);
          }}
          successText="Note Submitted !"
        />
      </section>
    </>
  );
}

export default Special_Instructions_Modal;
